<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Origens">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input
                    id="id"
                    placeholder="ID"
                    v-model="form._id"
                    disabled
                  />
                  <label for="id">ID</label>
                </div>
              </b-col> -->

              <b-col md="12"></b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <b-form-input
                    id="name"
                    placeholder="Nome"
                    v-model="form.name"
                  />
                  <label for="name">Nome</label>
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <b-form-input
                    id="code"
                    placeholder="Código"
                    v-model="form.code"
                  />
                  <label for="code">Código</label>
                </div>
              </b-col>
              <!-- <b-col md="4">
                <div class="form-label-group">
                  <b-form-input
                    id="redis_queue"
                    placeholder="Redis Queue"
                    v-model="form.redis_queue"
                  />
                  <label for="redis_queue">Redis Queue</label>
                </div>
              </b-col> -->

              <b-col md="12">
                <div class="form-label-group">
                  <label for="origin-list">Canal</label>
                  <b-form-group label="Canal" label-for="origin-list">
                    <v-select
                      id="channel-list"
                      v-model="form.channel"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="channel"
                    >
                      <span slot="no-options">{{
                        $t("GENERAL.NoOptions")
                      }}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="4">
                <span class="lbl-form-send-news"
                  >{{ $t("SEND_NEWS.Country") }}
                </span>
                <v-select
                  id="country"
                  :placeholder="$t('SEND_NEWS.Country_Placeholder')"
                  v-model="form.country"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  multiple
                  :options="countries"
                  :tabindex="2"
                >
                  <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                </v-select>
              </b-col>
              <!-- <b-col md="3">
                <div
                  class="form-label-group"
                  style="margin-bottom: 0px; margin-top: 30px"
                >
                  <label for="language">Idioma</label>
                  <b-form-input
                    id="language"
                    placeholder="Idioma"
                    v-model="countryLanguage"
                    disabled
                  />
                </div>
              </b-col> -->

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="active"
                    name="active"
                    v-model="form.active"
                  >
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="legacy"
                    name="legacy"
                    v-model="form.legacy"
                  >
                    Legado
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <b-form-checkbox
                    id="displayInSendNews"
                    name="displayInSendNews"
                    v-model="form.displayInSendNews"
                  >
                    Mostrar no formulário de envio de noticia
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <b-form-checkbox
                    id="sync_client_siga"
                    name="sync_client_siga"
                    v-model="form.sync_client_siga"
                  >
                    Sincronizar clientes sigaweb
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <b-form-checkbox
                    id="sync_origin_adv"
                    name="sync_origin_adv"
                    v-model="form.sync_origin_adv"
                  >
                    Cadastro da origem (Sincronizar com advanced)
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col>
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="onSubmit"
                >
                  Enviar
                </b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <b-tab title="Configuração" :disabled="!form.sync_origin_adv">
          <b-row>
            <b-col md="12"></b-col>
            <b-col md="4">
              <div class="form-label-group">
                <b-form-input
                  id="mnemonic"
                  placeholder="Mnemonico"
                  v-model="form.mnemonic"
                  maxlength="10"
                />
                <label for="mnemonic">Mnemonico</label>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-label-group">
                <b-form-input
                  id="description"
                  placeholder="Descrição"
                  v-model="form.description"
                  maxlength="40"
                />
                <label for="description">Descrição</label>
              </div>
            </b-col>

            <b-col md="4">
              <div class="form-label-group">
                <b-form-input
                  id="origin_location"
                  placeholder="Localidade da Origem"
                  v-model="form.origin_location"
                  maxlength="40"
                />
                <label for="origin_location">Localidade da Origem</label>
              </div>
            </b-col>
            <b-col md="4" style="margin-top: 20px">
              <div class="form-label-group">
                <b-form-input
                  id="fuso"
                  placeholder="Fuso"
                  v-model="form.fuso"
                  maxlength="40"
                />
                <label for="fuso">Fuso</label>
              </div>
            </b-col>
             <!-- <b-col md="12"></b-col> -->
             <b-col md="4">
              <div class="form-label-group">
                <b-form-group label="Status" label-for="status-list">
                  <v-select
                    id="status-list"
                    v-model="form.status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    
                    :options="status"
                  >
                  </v-select>
                </b-form-group>
              </div>
            </b-col>
             

            <b-col md="12">
              <label>Dias de Processo</label>
              <div class="origin-form-process-day">
                <b-form-checkbox v-model="form.process_days.sunday">Dom</b-form-checkbox>
                <b-form-checkbox v-model="form.process_days.monday">Seg</b-form-checkbox>
                <b-form-checkbox v-model="form.process_days.tuesday">Ter</b-form-checkbox>
                <b-form-checkbox v-model="form.process_days.wednesday">Qua</b-form-checkbox>
                <b-form-checkbox v-model="form.process_days.thursday">Qui</b-form-checkbox>
                <b-form-checkbox v-model="form.process_days.friday">Sex</b-form-checkbox>
                <b-form-checkbox v-model="form.process_days.saturday">Sab</b-form-checkbox>
              </div>
            </b-col>

            <b-col md="12"><hr></b-col>
            <b-col md="4">
              <label for="ini_process_hour">Hora Inicio Processo</label>
              <cleave
                id="ini_process_hour"
                v-model="form.ini_process_hour"
                class="form-control"
                :raw="false"
                :options="maskOptions.time"
                placeholder="hh:mm:ss"
              />
            </b-col>
            <b-col md="4">
              <label for="end_process_hour">Hora Final Processo</label>
              <cleave
                id="end_process_hour"
                v-model="form.end_process_hour"
                class="form-control"
                :raw="false"
                :options="maskOptions.time"
                placeholder="hh:mm:ss"
              />
            </b-col>
            <b-col md="4">
              <label for="ini_regular_hour">Hora Inicio Regular</label>
              <cleave
                id="ini_regular_hour"
                v-model="form.ini_regular_hour"
                class="form-control"
                :raw="false"
                :options="maskOptions.time"
                placeholder="hh:mm:ss"
              />
            </b-col>
            <b-col md="4">
              <label for="end_regular_hour">Hora Fim Regular</label>
              <cleave
                id="end_regular_hour"
                v-model="form.end_regular_hour"
                class="form-control"
                :raw="false"
                :options="maskOptions.time"
                placeholder="hh:mm:ss"
              />
            </b-col>
            <b-col md="4">
              <label for="ini_night_hour">Hora Inicio Noturno</label>
              <cleave
                id="ini_night_hour"
                v-model="form.ini_night_hour"
                class="form-control"
                :raw="false"
                :options="maskOptions.time"
                placeholder="hh:mm:ss"
              />
            </b-col>
            <b-col md="4">
              <label for="end_night_hour">Hora Fim Noturno</label>
              <cleave
                id="end_night_hour"
                v-model="form.end_night_hour"
                class="form-control"
                :raw="false"
                :options="maskOptions.time"
                placeholder="hh:mm:ss"
              />
            </b-col>

            <b-col md="12" style="margin-bottom: 10px"><hr></b-col>

            <b-col md="4">
              <div class="form-label-group">
                <b-form-input
                  id="s4_prefix"
                  placeholder="Prefixo S4"
                  v-model="form.s4_prefix"
                  maxlength="20"
                />
                <label for="s4_prefix">Prefixo S4</label>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-label-group">
                <b-form-input
                  id="market"
                  placeholder="Mercados"
                  v-model="form.market"
                  maxlength="20"
                />
                <label for="market">Mercados</label>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-label-group">
                <b-form-input
                  id="holiday_group"
                  placeholder="Grupo Feriado"
                  v-model="form.holiday_group"
                  maxlength="20"
                />
                <label for="holiday_group">Grupo Feriado</label>
              </div>
            </b-col>

            <b-col md="12"></b-col>

            <b-col md="4">
              <div class="form-label-group">
                <b-form-group label="Tipo Quotes" label-for="quotes-list">
                  <v-select
                    id="quotes-list"
                    v-model="form.quotes"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :reduce="val => val.id"
                    label="name"
                    :options="type_ys"
                  >
                  </v-select>
                </b-form-group>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-label-group">
                <label for="rates-list">Tipo Rates</label>
                <b-form-group label="Tipo Rates" label-for="rates-list">
                  <v-select
                    id="rates-list"
                    v-model="form.rates"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :reduce="val => val.id"
                    label="name"
                    :options="type_ys"
                  >
                  </v-select>
                </b-form-group>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-label-group">
                <label for="news-list">Tipo News</label>
                <b-form-group label="Tipo News" label-for="news-list">
                  <v-select
                    id="news-list"
                    v-model="form.news"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :reduce="val => val.id"
                    label="name"
                    :options="type_ys"
                  >
                  </v-select>
                </b-form-group>
              </div>
            </b-col>


          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import originService from "@/providers/originService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import vSelect from "vue-select";
import dropdownService from "@/providers/dropdownService";
import AppConstants from "@/appConstants";
import Cleave from "vue-cleave-component";

export default {
  props: {},
  data() {
    return {
      dataID: null,
      displayOriginsApp: false,
      origins_app: [],
      channel: [],
      countries: [],
      type_ys: AppConstants.ORIGIN_TYPE_YN,
      status: AppConstants.ORIGIN_STATUS,
      countryLanguage: "",
      form: {
        _id: "",
        name: "",
        code: null,
        sync_client_siga: false,
        displayInPlatformMenu: false,
        displayInSendNews: true,
        active: true,
        legacy: true,
        sync_origin_adv: false,
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
        // email_template_path: "",
        // isApp: false,
        // origins_app: [],
        channel: [],
        country: [],
        redis_queue: "",
        mnemonic: "",
        description: "",
        status: "",
        origin_location: "",
        process_days: {
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
        },
        fuso: "",
        ini_process_hour: "",
        end_process_hour: "",
        s4_prefix: "",
        market: "",
        ini_regular_hour: "",
        end_regular_hour: "",
        ini_night_hour: "",
        end_night_hour: "",
        holiday_group: "",
        quotes: "",
        rates: "",
        news: ""
      },
      maskOptions: {
        time: {
          time: true,
          timePattern: ["h", "m", "s"],
        },
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", "Nova Origem");
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      console.log("dataid: ", this.dataID);
    }
    this.loadData();
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  watch: {
    // "form.country"(val) {
    //   if (val) {
    //     this.countryLanguage = val.language.name;
    //   } else {
    //     this.countryLanguage = "";
    //   }
    // },
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", "Nova Origem");
      }
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_ORIGIN);
    },
    onSubmit() {
      const sendform = JSON.parse(JSON.stringify(this.form));
      if (sendform.channel.length > 0) {
        sendform.channel = sendform.channel.map((item) => item.id || "");
      }
      if (sendform.status) {
        sendform.status = sendform.status.id;
      }
      originService
        .registerOrigin(sendform, new URLSearchParams())
        .then((res) => {
          console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getOriginDetail() {
      const params = new URLSearchParams();
      originService
        .getOriginDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.code = res.code;
          this.form.active = res.active;
          this.form.legacy = res.legacy;
          this.form.sync_client_siga = res.sync_client_siga;
          this.form.displayInPlatformMenu = res.displayInPlatformMenu;
          this.form.displayInSendNews = res.displayInSendNews;
          if (res.country) {
            this.form.country = this.countries.filter((item) => res.country.findIndex(c => c.id == item.id) >= 0);
          }
          // this.form.email_template_path = res.email_template_path;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(
            res.dt_create
          );
          this.form.dt_update = res.dt_update
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_update)
            : res.dt_update;
          this.form.dt_delete = res.dt_delete
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete)
            : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
          // this.form.origins_app = res.origins_app;
          // this.form.isApp = res.isApp;
          // this.form.redis_queue = res.redis_queue;
          this.form.channel = res.channel;
          this.form.sync_origin_adv = res.sync_origin_adv;
          this.form.mnemonic = res.mnemonic;
          this.form.description = res.description;
          this.form.status = AppConstants.ORIGIN_STATUS.find(item => item.id == res.status);
          this.form.origin_location = res.origin_location;
          this.form.process_days = res.process_days;
          this.form.fuso = res.fuso;
          this.form.ini_process_hour = res.ini_process_hour;
          this.form.end_process_hour = res.end_process_hour;
          this.form.s4_prefix = res.s4_prefix;
          this.form.market = res.market;
          this.form.ini_regular_hour = res.ini_regular_hour;
          this.form.end_regular_hour = res.end_regular_hour;
          this.form.ini_night_hour = res.ini_night_hour;
          this.form.end_night_hour = res.end_night_hour;
          if (res.holiday_group) {
            this.form.holiday_group = res.holiday_group.toString();
          }
          this.form.quotes = res.quotes;
          this.form.rates = res.rates;
          this.form.news = res.news;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      const params = new URLSearchParams();
      // params.append('onlyApp', true);
      Promise.all([
        // dropdownService.getAllOrigin(params),
        dropdownService.getChannel(params),
        dropdownService.getCountry(params),
      ])
        .then((res) => {
          // this.origins_app = res[0];
          this.channel = res[0];
          this.countries = res[1];
          if (this.dataID) {
            this.getOriginDetail();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect,
    Cleave,
  },
};
</script>

<style lang="scss">
</style>
